import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '@app/core/domain';
import { UserStore, UserStateModel } from './user.store';

@Injectable()
export class UserQuery extends Query<UserStateModel> {

  constructor(protected store: UserStore) {
    super(store);
  }

  isLoading(): Observable<boolean> {
    return this.select(state => state.loading);
  }

  getUserSnapshot(): User {
    return this.getValue().user;
  }

  getUser(): Observable<User> {
    return this.select(state => state.user);
  }

  userHasPlcCard(): Observable<boolean> {
    return this
      .select(state => state.user)
      .pipe(map((user: User) => user ? user.containsPlcCard : false));
  }
}
